import sidebar from '@/config/sidebars/geogrids'
import createVueApp from '@/common/create_app'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

// The full payload hydrates the common geogrids store (it picks what it
// needs). The component only receives its per-page params — passing the rest
// would turn them into fallthrough attrs on a fragment root and trip Vue's
// "extraneous attrs" warning.
const hydrateCommon = (data) => (pinia) => {
  useGeogridsCommonStore(pinia).initialize(data)
}

Styxie.Initializers.LiveGeogrids = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/live/index/index.vue')
    createVueApp(Component, { sidebar, state: hydrateCommon(props) })
  },
  new: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/live/new/index.vue')
    createVueApp(Component, { sidebar, state: hydrateCommon(props) })
  },
  show: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/live/show/index.vue')
    const { geogridId } = props
    createVueApp(Component, { props: { geogridId }, sidebar, state: hydrateCommon(props) })
  }
}
